/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-08-12 11:41:39
 * @LastEditTime : 2022-08-12 11:43:26
 * @LastEditors  : yangxr
 * @Description  : 甲供工程API
 * @FilePath     : \icps_fb\src\api\GHnumber\firstEngin.js
 */
//import request from '@/utils/request'
export const queryPage = '/icps/system/sign/cloudSell/engineeringManagement/QueryBindingContractPage'